import React from 'react';

interface IRowProps {
  data: any;
}

const ExpandedListRow: React.FC<IRowProps> = ({ data }) => {
  return (
    <div className='third-row'>
      <div className='tr-icon-cell'>
        <div className='tr-icon-frame'>
          <div className='tr-icon-svg'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='20'
              height='20'
              viewBox='0 0 20 20'
              fill='none'
            >
              <path
                d='M17.4334 10.5167C17.3938 10.4144 17.3343 10.3209 17.2584 10.2417L14.7584 7.74167C14.6015 7.58475 14.3887 7.49659 14.1667 7.49659C13.9448 7.49659 13.732 7.58475 13.5751 7.74167C13.4182 7.89859 13.33 8.11142 13.33 8.33333C13.33 8.55525 13.4182 8.76808 13.5751 8.925L14.6584 10H6.66675C6.44573 10 6.23377 9.9122 6.07749 9.75592C5.92121 9.59964 5.83341 9.38768 5.83341 9.16667V5.83333C5.83341 5.61232 5.74562 5.40036 5.58934 5.24408C5.43306 5.0878 5.2211 5 5.00008 5C4.77907 5 4.56711 5.0878 4.41083 5.24408C4.25455 5.40036 4.16675 5.61232 4.16675 5.83333V9.16667C4.16675 9.82971 4.43014 10.4656 4.89898 10.9344C5.36782 11.4033 6.00371 11.6667 6.66675 11.6667H14.6584L13.5751 12.7417C13.497 12.8191 13.435 12.9113 13.3927 13.0129C13.3504 13.1144 13.3286 13.2233 13.3286 13.3333C13.3286 13.4433 13.3504 13.5523 13.3927 13.6538C13.435 13.7554 13.497 13.8475 13.5751 13.925C13.6526 14.0031 13.7447 14.0651 13.8463 14.1074C13.9478 14.1497 14.0567 14.1715 14.1667 14.1715C14.2768 14.1715 14.3857 14.1497 14.4872 14.1074C14.5888 14.0651 14.6809 14.0031 14.7584 13.925L17.2584 11.425C17.3343 11.3457 17.3938 11.2523 17.4334 11.15C17.5168 10.9471 17.5168 10.7196 17.4334 10.5167Z'
                fill='var(--alternative-text-color)'
              />
            </svg>
          </div>
        </div>
      </div>
      <div className='tr-primary-col'>
        <div className='tr-primary-header'>
          <div className='tr-primary-header-typo'>{data.key}</div>
        </div>
      </div>
      <div className='tr-end-col'>
        <div className='tr-end-header'>
          <div className='tr-end-header-typo'>{data.doc_count}</div>
        </div>
      </div>
    </div>
  );
};

export default ExpandedListRow;
